"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("./Style.css");

var _idbReactUiElements = require("@identitybuilding/idb-react-ui-elements");

var _Gallery = _interopRequireDefault(require("./components/Gallery"));

var _Lightbox = _interopRequireDefault(require("./components/Lightbox"));

var _react = _interopRequireWildcard(require("react"));

var _Slider = _interopRequireDefault(require("./components/Slider"));

var _idbReactTranslations = _interopRequireDefault(require("@identitybuilding/idb-react-translations"));

var _axios = _interopRequireDefault(require("axios"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// Main component to render current offers
var CurrentOffers = /*#__PURE__*/function (_Component) {
  _inherits(CurrentOffers, _Component);

  var _super = _createSuper(CurrentOffers);

  function CurrentOffers(props) {
    var _this;

    _classCallCheck(this, CurrentOffers);

    _this = _super.call(this, props);
    _this.state = {
      active_collection: 0,
      creads: {
        title: "",
        creads: []
      },
      lightbox: false,
      view: _this.props.view ? _this.props.view : "slideshow"
    };

    _this.translate = function (e) {
      return (0, _idbReactTranslations["default"])(e, props.lang);
    };

    return _this;
  }

  _createClass(CurrentOffers, [{
    key: "getData",
    value: function () {
      var _getData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var collections, as_model, creads, gallery_only;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                collections = [];
                as_model = require('./models/CurrentOffersModel')["default"]; // collections = await axios.get(`http://localhost:8000/core/api/business/${this.props.id}/creads/`)

                _context.next = 4;
                return _axios["default"].get("https://management.100procentlokaal.be/core/api/business/".concat(this.props.id, "/creads/?lang=").concat(this.props.lang)).then(function (res) {
                  return as_model(res.data, _this2.props.lang);
                })["catch"](function (error) {
                  return console.log(error);
                });

              case 4:
                collections = _context.sent;
                this.setState({
                  cread_collections: collections
                });
                this.props.setCreadCollections(collections);

                if (collections) {
                  if (collections.length > 0) {
                    creads = this.props.bpIndex === 'all' ? collections.all : collections[this.state.active_collection], gallery_only = creads.creads.length < 4;
                    this.setState({
                      creads: creads,
                      gallery_only: gallery_only
                    });

                    if (!this.props.view) {
                      this.setState({
                        view: gallery_only ? 'gallery' : 'slideshow'
                      });
                    }
                  }
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }()
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.creadCollections.length === 0) {
        this.getData();
      } else {
        this.setState({
          cread_collections: this.props.creadCollections
        });
        var creads = this.props.creadCollections[this.state.active_collection],
            gallery_only = creads.creads.length < 4;
        this.setState({
          creads: creads,
          gallery_only: gallery_only
        });

        if (!this.props.view) {
          this.setState({
            view: gallery_only ? 'gallery' : 'slideshow'
          });
        }
      } // On mobile size, set default view to gallery
      // const sectionWidth = document.getElementById("currentOffers").clientWidth
      // if (sectionWidth <= 768) this.setState({ view: "gallery" })

    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.bpIndex !== prevProps.bpIndex) {
        this.setState({
          active_collection: this.props.bpIndex
        });
        this.setupCollection(this.props.bpIndex);
      }

      if (this.props.view !== prevProps.view) {
        this.setState({
          view: this.props.view
        });
      }
    } // Handles the lightbox navigation

  }, {
    key: "lightboxHandler",
    value: function lightboxHandler(i, type) {
      this.setState({
        lightbox: type === "next" ? i === this.state.creads.creads.length - 1 ? 0 : i + 1 : type === "prev" ? i === 0 ? this.state.creads.creads.length - 1 : i - 1 : type === "initial" ? i : false
      });
    }
  }, {
    key: "setupCollection",
    value: function setupCollection(index) {
      var new_creads = this.state.cread_collections[index];
      var gallery_only = new_creads.creads.length < 4,
          view = gallery_only ? "gallery" : 'slideshow';

      if (this.state.cread_collections[this.state.active_collection].creads.length < 4 && !gallery_only) {
        view = 'slideshow';
      }

      this.setState({
        active_collection: index,
        creads: new_creads,
        gallery_only: gallery_only,
        view: view
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var theme = this.props.theme,
          _this$state = this.state,
          active_collection = _this$state.active_collection,
          creads = _this$state.creads,
          lightbox = _this$state.lightbox,
          gallery_only = _this$state.gallery_only,
          view = _this$state.view,
          cread_collections = _this$state.cread_collections;
      return /*#__PURE__*/_react["default"].createElement("section", {
        className: "".concat(view === "slideshow" ? "slideshow" : "gallery", " ").concat(theme ? theme : "light"),
        id: "currentOffers"
      }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, typeof lightbox === "number" && /*#__PURE__*/_react["default"].createElement(_Lightbox["default"], {
        lightboxHandler: function lightboxHandler(i, dir) {
          return _this3.lightboxHandler(i, dir);
        },
        closeLightbox: function closeLightbox() {
          return _this3.setState({
            lightbox: false
          });
        },
        index: lightbox,
        result: this.state.creads.creads[lightbox],
        results: this.state.creads.creads,
        lang: this.props.lang
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "sectionWrapper"
      }, this.props.title ? /*#__PURE__*/_react["default"].createElement("h2", null, this.translate(this.props.title)) : /*#__PURE__*/_react["default"].createElement("h2", null, this.translate("current_offers")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "current_offers_toolbar"
      }, cread_collections && cread_collections.length > 1 && this.props.bpIndex === undefined && /*#__PURE__*/_react["default"].createElement("div", {
        className: "current_offers_buttons"
      }, cread_collections.map(function (collection, index) {
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: index === active_collection ? "active" : "",
          key: index,
          onClick: function onClick() {
            _this3.setupCollection(index);
          }
        }, collection.title);
      })), !gallery_only && !this.props.view && /*#__PURE__*/_react["default"].createElement(_idbReactUiElements.OsnIconBox, {
        items: [{
          active: view === "slideshow",
          icon: "SlideshowView",
          name: "Slideshow",
          onClick: function onClick() {
            return _this3.setState({
              view: "slideshow"
            });
          },
          render: function render(icon) {
            return icon;
          }
        }, {
          active: view === "gallery",
          icon: "GridView",
          name: "Gallery",
          onClick: function onClick() {
            return _this3.setState({
              view: "gallery"
            });
          },
          render: function render(icon) {
            return icon;
          }
        }]
      })), creads.creads.length > 0 && gallery_only ? /*#__PURE__*/_react["default"].createElement(_Gallery["default"], {
        creads: creads.creads,
        setLightbox: function setLightbox(index) {
          return _this3.lightboxHandler(index, "initial");
        }
      }) : view === "gallery" ? /*#__PURE__*/_react["default"].createElement(_Gallery["default"], {
        creads: creads.creads,
        setLightbox: function setLightbox(index) {
          return _this3.lightboxHandler(index, "initial");
        }
      }) : /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
        lightbox: lightbox,
        creads: creads.creads,
        setLightbox: function setLightbox(index) {
          _this3.lightboxHandler(index, "initial");
        }
      }))));
    }
  }]);

  return CurrentOffers;
}(_react.Component);

exports["default"] = CurrentOffers;